import type { MessageToolDocument, MessageToolDocumentsData } from "@virtual-brain-lib/types";

import { ToolCard, ToolCardSteps } from "../core";
import { ToolCardDocumentList } from "./ToolCardDocumentList";

export function ToolCardDocuments({
	state,
	onDocumentClick,
	className,
}: {
	readonly state: MessageToolDocumentsData;
	readonly onDocumentClick?: (doc: MessageToolDocument) => void;
	readonly className?: string;
}) {
	const { status, statusText, steps, documents, contentReferenceOffset } = state;

	if (status !== "processing" && documents.length === 0 && steps.length === 0) {
		return null;
	}

	const count = documents.length;
	const documentsFoundText =
		count > 0 ? `${count} document${count > 1 ? "s" : ""} found` : undefined;

	const getStatusText = () => {
		if (statusText) {
			return statusText;
		}

		if (status === "processing") {
			return "Searching documents in your brain";
		}

		return documentsFoundText;
	};

	const displayedCompactSummary = status === "processing" ? undefined : documentsFoundText;

	return (
		<ToolCard
			className={className}
			icon="file"
			status={status}
			statusText={getStatusText()}
			compactSummary={displayedCompactSummary}
			title="Documents"
		>
			{steps.length > 0 && <ToolCardSteps steps={steps} />}
			<ToolCardDocumentList
				documents={documents}
				contentReferenceOffset={contentReferenceOffset}
				onDocumentClick={onDocumentClick}
			/>
		</ToolCard>
	);
}
